import { FixaListView } from "@coworker/apprestructured/src/shared/wrappers/FixaListView/FixaListView";
import { Item } from "@coworker/apprestructured/src/shared/types/item";
import { SearchResultsListViewItem } from "@coworker/apprestructured/src/scan-and-search/components/searchResults/SearchResultsListViewItem/SearchResultsListViewItem";
import { SearchItemCardRenderType } from "@coworker/apprestructured/src/scan-and-search/types/SearchItemCardRenderType";

interface SearchResultsListViewProps {
  items: Item[];
  itemCardRenderType?: SearchItemCardRenderType;
  handleItemCardClick?: (item: Item) => void;
}

export const SearchResultsListView = ({
  items,
  itemCardRenderType = SearchItemCardRenderType.link,
  handleItemCardClick = () => {},
}: SearchResultsListViewProps) => {
  return (
    <FixaListView id={"search-results-list-view"} size={"small"}>
      {items.map((item: Item) => (
        <SearchResultsListViewItem
          key={item.no}
          item={item}
          itemCardRenderType={itemCardRenderType}
          handleItemCardClick={handleItemCardClick}
        />
      ))}
    </FixaListView>
  );
};
